import { ROUTE_CONFIG } from "@/routes/config";

const STORAGE_KEY = "signalist:pending-mcp-consent";

/**
 * Login does not remember where the user was heading, so an unauthenticated visit to the MCP
 * consent screen would end on the dashboard with the authorization request silently dropped
 * (docs/brief-mcp-server.md §"Tier 4"). The consent screen parks the request id here before
 * sending the user to log in, and the public router hands them back afterwards.
 *
 * Session-scoped and single-use: it is cleared the moment it is consumed, so a stale id can never
 * hijack a later login.
 */
export function rememberPendingConsent(requestId: string): void {
	try {
		sessionStorage.setItem(STORAGE_KEY, requestId);
	} catch {
		// Storage can be unavailable (private mode, sandboxed embed) — the user simply lands on
		// the dashboard and reconnects from their MCP client.
	}
}

/** Returns the consent route to resume, or null. Consumes the stored id either way. */
export function takePendingConsentRoute(): string | null {
	try {
		const requestId = sessionStorage.getItem(STORAGE_KEY);

		sessionStorage.removeItem(STORAGE_KEY);

		return requestId
			? `${ROUTE_CONFIG.MCP_CONSENT}?request_id=${encodeURIComponent(requestId)}`
			: null;
	} catch {
		return null;
	}
}
